// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { BarChart3 as RawBarChart3 } from "lucide-react";
export const BarChart3 = /* @__PURE__ */ createIcon(RawBarChart3, "BarChart3", 2);
